var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3420bb189b2ae601d2cd9df25d948990.svg#k';
                    var viewUrl = 'sprites.3420bb189b2ae601d2cd9df25d948990.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 62 58',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };